import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import MessageRecipientsMultiSelectWithCheckList from './MessageRecipientsMultiSelectWithCheckList';

interface Props extends BaseFieldProps {
	portal?: boolean;
	enableGroups?: boolean;
}

const MessageRecipientsMultiSelectWithCheckListField: React.FC<
	Props
> = props => (
	<BaseField {...props}>
		<MessageRecipientsMultiSelectWithCheckList
			portal={props.portal}
			enableGroups={props.enableGroups}
		/>
	</BaseField>
);

export default MessageRecipientsMultiSelectWithCheckListField;
